(function(angular, module) {var TagFilterController, URLTagListsController, arrayAdd, arrayRemove, tagFilterDirective, urlTagListDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

URLTagListsController = (function() {

  /* @ngInject */
  function URLTagListsController($scope, TagService, $timeout) {
    this.rebuildParams = bind(this.rebuildParams, this);
    var changeTimeout;
    this.TagService = TagService;
    this.tagLists = [];
    this.params = this.TagService.getParamsFromUrl();
    changeTimeout = null;
    this.paramsChanged = (function(_this) {
      return function() {
        $timeout.cancel(changeTimeout);
        return changeTimeout = $timeout(_this.rebuildParams);
      };
    })(this);
  }

  URLTagListsController.prototype.getListParams = function() {
    var list;
    return (function() {
      var i, len, ref, results;
      ref = this.tagLists;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        list = ref[i];
        results.push(list.params);
      }
      return results;
    }).call(this);
  };

  URLTagListsController.prototype.addTagList = function(list) {
    var index;
    index = this.tagLists.indexOf(list);
    if (index === -1) {
      this.tagLists.push(list);
      list.loadTags(this.params);
    }
  };

  URLTagListsController.prototype.removeTagList = function(list) {
    var index;
    index = this.tagLists.indexOf(list);
    if (index >= 0) {
      this.tagLists.splice(index, 1);
    }
  };

  URLTagListsController.prototype.rebuildParams = function() {
    this.params = angular.extend.apply(angular, [{}].concat(slice.call(this.getListParams())));
    this.TagService.paramsToUrl(this.params);
    this.onChange({
      params: this.params
    });
  };

  return URLTagListsController;

})();

TagFilterController = (function() {

  /* @ngInject */
  function TagFilterController(TagService, $attrs, $parse, $scope, $analytics) {
    this.analytics = $analytics;
    this.TagService = TagService;
    this.urlLinked = TagService.hasUrlTags();
    this.isOpen = false;
    this.tags = this.tags || [];
    this.tagGroups = {};
    this.tagLists = ['participant', 'program', 'location'];
    this.listLabels = {
      participant: 'For students tagged',
      program: 'For programs tagged',
      location: 'Located in'
    };
    if (this.addTagLabel == null) {
      this.addTagLabel = 'Filter report by tags';
    }
    if (this.program && this.skipIfProgram) {
      this.skip = this.skip ? this.skip + "." + this.skipIfProgram : this.skipIfProgram;
    }
    if ($attrs.controller != null) {
      $parse($attrs.controller).assign($scope.$parent, this);
    }
    if (this.urlLinked) {
      this.initializeTags();
    }
  }

  TagFilterController.prototype.track = function(name, label) {
    return this.analytics.eventTrack(name, {
      category: 'Tag Picker',
      label: label
    });
  };

  TagFilterController.prototype.open = function() {
    this.isOpen = true;
    this.track('open');
  };

  TagFilterController.prototype.close = function() {
    this.isOpen = false;
    this.track('close');
  };

  TagFilterController.prototype.initializeTags = function() {
    var params;
    params = this.TagService.getParamsFromUrl();
    if (this.program) {
      params.program_id = this.program.id;
    }
    return this.TagService.lookupTags(params).then((function(_this) {
      return function(tags) {
        var i, len, tag;
        for (i = 0, len = tags.length; i < len; i++) {
          tag = tags[i];
          _this.addTag(tag);
        }
        _this.params = _this.buildParams();
        _this.onChange({
          params: _this.params
        });
        return tags;
      };
    })(this));
  };

  TagFilterController.prototype.lookupRawTag = function(tag) {
    var params;
    params = {};
    params[tag.slug] = tag.value;
    params.program_id = this.program ? this.program.id : void 0;
    return this.TagService.lookupTags(params).then((function(_this) {
      return function(tags) {
        return tags[0];
      };
    })(this));
  };

  TagFilterController.prototype.addRawTag = function(tag) {
    return this.lookupRawTag(tag).then((function(_this) {
      return function(tag) {
        _this.addTag(tag);
        return tag;
      };
    })(this));
  };

  TagFilterController.prototype.addTag = function(tag) {
    this.track('add', tag.slug + "=" + tag.value);
    this.tagGroups[tag.tag_for] = this.tagGroups[tag.tag_for] || [];
    arrayAdd(this.tags, tag);
    arrayAdd(this.tagGroups[tag.tag_for], tag);
    this.params = this.buildParams();
    this.onChange({
      params: this.params
    });
  };

  TagFilterController.prototype.removeTag = function(tag) {
    tag = this.tags.find(function(t) {
      return t.slug === tag.slug && t.value === tag.value;
    });
    if (!tag) {
      return;
    }
    this.track('remove', tag.slug + "=" + tag.value);
    this.tagGroups[tag.tag_for] = this.tagGroups[tag.tag_for] || [];
    arrayRemove(this.tags, tag);
    arrayRemove(this.tagGroups[tag.tag_for], tag);
    this.params = this.buildParams();
    this.onChange({
      params: this.params
    });
  };

  TagFilterController.prototype.buildParams = function() {
    var i, len, params, ref, tag;
    params = {};
    ref = this.tags;
    for (i = 0, len = ref.length; i < len; i++) {
      tag = ref[i];
      params[tag.slug] = params[tag.slug] || [];
      params[tag.slug].push(tag.value);
    }
    if (this.urlLinked) {
      this.TagService.paramsToUrl(params);
    }
    return params;
  };

  return TagFilterController;

})();

arrayRemove = function(array, value) {
  var index;
  index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
};

arrayAdd = function(array, value) {
  var index;
  if (array == null) {
    array = [];
  }
  index = array.indexOf(value);
  array.push(value);
};

urlTagListDirective = function() {
  return {
    restrict: 'E',
    scope: {},
    controller: URLTagListsController,
    controllerAs: 'ctrl',
    bindToController: {
      program: '=',
      params: '=',
      onChange: '&'
    }
  };
};

tagFilterDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'util/tags/tagFilter',
    controller: TagFilterController,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      program: '=',
      params: '=?',
      tags: '=?',
      onChange: '&',
      skip: '@',
      skipIfProgram: '@',
      addTagLabel: '@'
    }
  };
};

module.directive('dybUrlTagLists', urlTagListDirective);

module.directive('dybTagFilter', tagFilterDirective);
})(angular, angular.module("dybTags"));